import { RoutePath } from './route-path'
//Admin Portal
import AdminLoginPage from "admin-portal/user/login";
import AdminOTPPage from "admin-portal/user/otp";
import AdminSwitchTenantPage from "admin-portal/user/switch-tenant";
import AdminLogout from "admin-portal/user/logout";
import AdminForgetPasswordPage from "admin-portal/user/forget-password";
import AdminResetPasswordPage from "admin-portal/user/reset-password";

// dashboard
import AdminDashboard from "admin-portal/dashboard";

import AdminUserProfile from "admin-portal/user/profile";

//tenant
import TenantEditPage from "admin-portal/tenant/tenant-edit-page"

//setups
import ServiceTypePage from "admin-portal/setup/service-type-page"
import ServicesPage from "admin-portal/setup/services-page"
import ProductsPage from "admin-portal/setup/products-page"
import PromotionPage from "admin-portal/setup/promotion-page"
import VehicleModelImportPage from "admin-portal/setup/vehicle-model-import-page"

//Subscriptions
import SubscriptionPage from "admin-portal/subscription/index"

//Jobs
import JobsPage from "admin-portal/job/index"
import JobListPage from "admin-portal/job/job-list"
import JobEditPage from "admin-portal/job/job-edit"
import InvoicePreviewPage from "admin-portal/job/invoice-preview"
import VehiclesPage from "admin-portal/vehicle/index"
import CustomersPage from "admin-portal/customer/index"

import DailySalesReport from "admin-portal/reports/daily-sales-report"
import ProductsReport from "admin-portal/reports/products"
import RevenueReport from "admin-portal/reports/revenue-report"

//Referrer Management
import ReferrerPage from "admin-portal/referrer/index";
interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}


//Admin Portal
const adminPublicRoutes: Array<RouteObject> = [
  //Login
  { path: RoutePath.Admin_Login_page, component: AdminLoginPage },
  { path: RoutePath.Admin_Login_OTP, component: AdminOTPPage },
  { path: RoutePath.Admin_Login_Switch_tenant, component: AdminSwitchTenantPage },
  { path: RoutePath.Admin_Login_Logout, component: AdminLogout },
  { path: RoutePath.Admin_ForgetPassword, component: AdminForgetPasswordPage },
  { path: RoutePath.Admin_ResetPassword, component: AdminResetPasswordPage }
]
const adminProtectedRoutes: Array<RouteObject> = [
  { path: "/", component: AdminDashboard },
  { path: RoutePath.Admin_Dashborad_page, component: AdminDashboard },
  { path: RoutePath.Admin_Profile, component: AdminUserProfile },


  { path: RoutePath.Admin_TenantManage, component: TenantEditPage },

  { path: RoutePath.Admin_ServiceTypes, component: ServiceTypePage },
  { path: RoutePath.Admin_Services, component: ServicesPage },
  { path: RoutePath.Admin_Products, component: ProductsPage },
  { path: RoutePath.Admin_Promotions, component: PromotionPage },
  { path: RoutePath.Admin_VehicleModels, component: VehicleModelImportPage },

  { path: RoutePath.Admin_Subscriptions, component: SubscriptionPage },


  // { path: RoutePath.Admin_Customers, component: ServiceTypePage },
  { path: RoutePath.Admin_Vehicles, component: VehiclesPage },
  { path: RoutePath.Admin_Customers, component: CustomersPage },
  { path: RoutePath.Admin_Job_create, component: JobsPage },
  { path: RoutePath.Admin_Job_list, component: JobListPage },
  { path: RoutePath.Admin_Job_edit, component: JobEditPage },
  { path: RoutePath.Admin_Job_invoice_preview, component: InvoicePreviewPage },

  //Reports
  { path: RoutePath.Admin_Report_Daily_Sales, component: DailySalesReport },
  { path: RoutePath.Admin_Report_Products, component: ProductsReport },
  //{ path: RoutePath.Admin_Report_Services, component: DailySalesReport },
  { path: RoutePath.Admin_Report_Revenue, component: RevenueReport },

  //Referrer Management
  { path: RoutePath.Admin_Referrer, component: ReferrerPage },
]





export {
  adminPublicRoutes, adminProtectedRoutes
};
